module.exports = __webpack_public_path__ + "img/about.3d4f5281.jpg";